module.exports = __webpack_public_path__ + "static/media/sign-in.ea051702.jpg";